import { useEffect, useRef } from "react";
import { reloadPage } from "../lib/reload";

// Reloads the page when `token` changes after the first real value was seen
// (tokens come from /api/config; negative = config not fetched yet, ignored).
// If `canReload` says no (e.g. a guest is mid-upload) the reload is simply
// retried a few seconds later instead of being dropped.
export function useReloadOnToken(token: number, canReload: () => boolean = () => true) {
  const initialToken = useRef<number | null>(null);
  const latestToken = useRef(token);
  const canReloadRef = useRef(canReload);
  latestToken.current = token;
  canReloadRef.current = canReload;

  useEffect(() => {
    if (token >= 0 && initialToken.current === null) initialToken.current = token;
  }, [token]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (initialToken.current === null || latestToken.current < 0) return;
      if (latestToken.current !== initialToken.current && canReloadRef.current()) reloadPage();
    }, 3000);
    return () => clearInterval(interval);
  }, []);
}
